import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from './api';
import { useAuth } from './AuthContext';
import { Loader2 } from 'lucide-react';
import { getStoredRef, clearStoredRef } from '../lib/growth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setError('Missing session_id in callback URL.');
      setTimeout(() => navigate('/app/login', { replace: true }), 1200);
      return;
    }

    (async () => {
      try {
        const ref = getStoredRef();
        const { user } = await authApi.exchangeSession(sessionId, ref);
        if (ref) clearStoredRef();
        setUser(user);
        // Clean fragment and route to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/app/dashboard', { replace: true, state: { user } });
      } catch (e) {
        setError(e.message || 'Sign-in failed. Please try again.');
        setTimeout(() => navigate('/app/login', { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0d0e] text-white" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-[#4FBCC7]" />
        <p className="text-sm text-white/70">{error ? error : 'Signing you in...'}</p>
      </div>
    </div>
  );
}
